const HOST =
  'https://raw.githubusercontent.com/IrynaStein/portfolio_images/main/';
export const buildArtworkLink = (imageName) => {
  return HOST + imageName + '.png';
};
